import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SpeechRecognitionApp from './components/SpeechRecognitionApp';
import { Register } from './components/Register';
import { Login } from './components/Login';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';

const App = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const ProtectedRoute = ({ children }) => {
    if (!isLoggedIn) {
      return <Navigate to='/login' />;
    }
    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={
            <ProtectedRoute>
              <SpeechRecognitionApp />
            </ProtectedRoute>
          }
        />
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        {/* You can add other routes here */}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
